import { useQuery } from 'react-query';
import * as api from '../../services/api';
import useAccount from './useAccount';

const useEmployeeCompliance = ({ employeeId }) => {
  const { accountId } = useAccount();
  const storeKey = ['compliance', accountId, employeeId];

  const { isLoading, data, refetch } = useQuery(
    storeKey,
    () => api.fetchEmployeeCompliance({ accountId, employeeId }),
    { staleTime: 0 }
  );

  return {
    isLoading,
    data: data?.data || [],
    refetch
  };
};

export default useEmployeeCompliance;
